import scribe from '@grab-x/scribe-web-sdk';

export function sendScribeEvent(
  eventName: string,
  data: { [key: string]: any },
) {
  try {
    const dataClone = JSON.parse(JSON.stringify(data));

    Object.keys(dataClone).forEach((key) => {
      const value = dataClone[key];

      if (!Array.isArray(value) && typeof value !== 'object') return;

      dataClone[key] = JSON.stringify(value);
    });

    scribe.sendEvent(eventName, dataClone);
  } catch (e) {
    console.error(e);
  }
}
